import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Olcutler.css';

function Olcutler() {
  const kriterler = [
    "Çalışma, alanın kapsamına ne derece uygundur?",
    "Çalışmanın konusu (çalışmada incelenen sorun) ne kadar merak uyandırıcı ve özgündür?",
    "Çalışma, bir teoriye/modele/çerçeveye ne derece dayandırılmıştır?",
    "Çalışma, ilgili yazından ne derece yararlanmıştır? (Konuyla ilgili ana çalışmalar hakkındaki farkındalık, güncel çalışmaların incelenmesi, hipotezlerin ilgili yazına dayandırılmış olması, vb.)",
    "Çalışmada, yazım kurallarına ne derece uyulmuştur?",
    "Önerilen/kullanılan yöntem çalışmanın amacıyla ne derece uyumludur?",
    "Yapılan/yapılacak veri analizleri ne derece doğru şekilde yürütülmüş/yürütülecektir?",
    "Muhtemel/ulaşılan sonuçlar çalışmanın amacıyla ne derece uyumludur?",
    "Çalışmada kullanılan dil, ne derece açık, anlaşılır ve akıcıdır?",
    "Bir bütün olarak çalışma, ilgili yazına (ya da uygulayıcılara) ne derece katkı yapmaktadır/yapacaktır?"
  ];

  return (
    <div className="olcutler-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>DEĞERLENDİRME ÖLÇÜTLERİ</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi Hakem Formu</p>
        </div>
      </header>

      <main className="content-container">
        <div className="table-card">
          <div className="table-header-main">
            <h3>Değerlendirme Ölçütleri</h3>
          </div>
          
          <div className="table-responsive">
            <table className="evaluation-table">
              <thead>
                <tr>
                  <th className="criteria-col">Değerlendirme Ölçütleri</th>
                  <th>Yetersiz</th>
                  <th>Az Yeterli</th>
                  <th>Yeterli</th>
                  <th>İyi</th>
                  <th>Mükemmel</th>
                </tr>
              </thead>
              <tbody>
                {kriterler.map((text, index) => (
                  <tr key={index}>
                    <td className="criteria-text">{text}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
                <tr className="footer-row">
                  <td className="criteria-text"><strong>Toplam Puan</strong></td>
                  <td colSpan="5"></td>
                </tr>
                <tr className="footer-row">
                  <td className="criteria-text"><strong>Yorum ve Öneriler</strong></td>
                  <td colSpan="5" className="comment-area"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Olcutler;